import { Accordion, AccordionDetails, AccordionSummary, Box, Typography } from "@mui/material";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import QuestionCard from "./QuestionCard";

const BlocksAdmin = ({blocks}) => {

    return (
    <Box sx={{marginTop:"40px",marginBottom:"100px"}}>
    {
        blocks && blocks.map((b,i)=>(
        <Accordion key={i} sx={{marginTop:"30px",padding:"10px 0px 10px 10px",border:"2px solid", borderColor:`${b.color}`,backgroundColor:`${b.color}`}}>
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{color:"white"}}/>}>
                <Typography variant="h5" fontWeight={600} color="white" dangerouslySetInnerHTML={{ __html: b.name }}/>
            </AccordionSummary>
            <AccordionDetails>
                <QuestionCard questions={b.questions} color={b.color}/>
            </AccordionDetails>
        </Accordion>
        ))
    }
    </Box>
    )
}

export default BlocksAdmin